import React from 'react';
import Nav from '../../components/Nav';
import NavLink from '../../feature-ui/nav-link';
import publicRoutes from '../../routes/public.routes';

function FooterNavFeature() {
  const routes = publicRoutes().filter(r => r.showInFooter === true);

  const renderNavItem = (link, i) => (
    <NavLink
      // active={link.path === pathname}
      to={link.path}
      color="inherit"
      weight="600"
      key={`footer-${link.slug}`}>
      {link.label}
    </NavLink>
  );

  return <Nav gap={4} items={routes} renderItem={renderNavItem} />;
}

export default FooterNavFeature;
